// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_wrapper__\\+Eka- {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Loader_wrapper__\\+Eka- .Loader_loader__tBTIj {
  width: 48px;
  height: 48px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  z-index: 0;
  animation: Loader_spin__bty6U 1s linear infinite;
  background: transparent;
}
.Loader_wrapper__\\+Eka- .Loader_loader__tBTIj > div:not(.Loader_blocker__41t7F) {
  width: 50%;
  height: 50%;
  z-index: -1;
}
.Loader_wrapper__\\+Eka- .Loader_loader__tBTIj .Loader_blocker__41t7F {
  position: absolute;
  top: 0;
  left: 0;
  width: 80%;
  height: 80%;
  top: 10%;
  left: 10%;
  border-radius: 100%;
  background: white;
}
.Loader_wrapper__\\+Eka- .Loader_loader__tBTIj .Loader_bottomLeft__gsfLi {
  position: absolute;
  top: 50%;
  left: 0;
  background: linear-gradient(to bottom right, rgba(105, 174, 223, 0.75) 0%, rgba(40, 127, 189, 0.5) 100%);
}
.Loader_wrapper__\\+Eka- .Loader_loader__tBTIj .Loader_bottomLeft__gsfLi::before {
  content: "";
  position: absolute;
  z-index: 0;
  top: -2px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: linear-gradient(180deg, rgba(40, 127, 189, 0.5) 0%, transparent 100%);
}
.Loader_wrapper__\\+Eka- .Loader_loader__tBTIj .Loader_bottomRight__Ax6mO {
  position: absolute;
  top: 50%;
  left: 50%;
  background: linear-gradient(to top right, rgba(40, 127, 189, 0.5) 0%, rgba(99, 205, 173, 0.25) 100%);
}
.Loader_wrapper__\\+Eka- .Loader_loader__tBTIj .Loader_topLeft__URy1w {
  position: absolute;
  top: 0;
  left: 50%;
  background: linear-gradient(to bottom right, rgba(49, 155, 136, 0) 0%, rgba(99, 205, 173, 0.25) 100%);
}
@keyframes Loader_spin__bty6U {
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Loader/Loader.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EAEA,gDAAA;EACA,uBAAA;AACJ;AACI;EACE,UAAA;EACA,WAAA;EACA,WAAA;AACN;AAEI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAAN;AAGI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EAEA,wGAAA;AADN;AAGM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EAEA,iFAAA;AADR;AAKI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,oGAAA;AAHN;AAMI;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EAEA,qGAAA;AAJN;AAeE;EACE;IAEU,yBAAA;EAPZ;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .loader {\n    width: 48px;\n    height: 48px;\n    position: relative;\n    border-radius: 50%;\n    overflow: hidden;\n    z-index: 0;\n    -webkit-animation: spin2 1s linear infinite;\n    animation: spin 1s linear infinite;\n    background: transparent;\n  \n    & > div:not(.blocker) {\n      width: 50%;\n      height: 50%;\n      z-index: -1;\n    }\n  \n    .blocker {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 80%;\n      height: 80%;\n      top: 10%;\n      left: 10%;\n      border-radius: 100%;\n      background: white;\n    }\n  \n    .bottomLeft {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      background: -webkit-linear-gradient(top left, rgba(105, 174, 223, 0.75) 0%, rgba(40, 127, 189, 0.5) 100%);\n      background: linear-gradient(to bottom right, rgba(105, 174, 223, 0.75) 0%, rgba(40, 127, 189, 0.5) 100%);\n    \n      &::before {\n        content: '';\n        position: absolute;\n        z-index: 0;\n        top: -2px;\n        left: 0;\n        width: 5px;\n        height: 5px;\n        border-radius: 50%;\n        background: -webkit-linear-gradient(180deg, rgba(40, 127, 189, 0.5) 0%, transparent 100%);\n        background: linear-gradient(180deg, rgba(40, 127, 189, 0.5) 0%, transparent 100%);\n      }\n    }\n  \n    .bottomRight {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      background: -webkit-linear-gradient(bottom left, rgba(40, 127, 189, 0.5) 0%, rgba(99, 205, 173, 0.25) 100%);\n      background: linear-gradient(to top right, rgba(40, 127, 189, 0.5)0%, rgba(99, 205, 173, 0.25) 100%);\n    }\n  \n    .topLeft {\n      position: absolute;\n      top: 0;\n      left: 50%;\n      background: -webkit-linear-gradient(top left, rgba(49, 155, 136, 0) 0%, rgba(99, 205, 173, 0.25) 100%);\n      background: linear-gradient(to bottom right, rgba(49, 155, 136, 0) 0%, rgba(99, 205, 173, 0.25) 100%);\n    }\n  }\n  \n  \n  @-webkit-keyframes spin {\n    100% {\n      -webkit-transform: rotate(360deg);\n              transform: rotate(360deg);\n    }\n  }\n  @keyframes spin {\n    100% {\n      -webkit-transform: rotate(360deg);\n              transform: rotate(360deg);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Loader_wrapper__+Eka-`,
	"loader": `Loader_loader__tBTIj`,
	"spin": `Loader_spin__bty6U`,
	"blocker": `Loader_blocker__41t7F`,
	"bottomLeft": `Loader_bottomLeft__gsfLi`,
	"bottomRight": `Loader_bottomRight__Ax6mO`,
	"topLeft": `Loader_topLeft__URy1w`
};
export default ___CSS_LOADER_EXPORT___;
